import { varIs, varKey, varLabel } from "common/var";
import {
  CountryFlag,
  RankBadge,
  TablePanel,
  UserAvatar,
} from "components/common";
import { useEffect, useState } from "react";
import { BsChatDots } from "react-icons/bs";
import {
  FaFacebookMessenger,
  FaTelegramPlane,
  FaWhatsapp,
} from "react-icons/fa";
import { callGetApiWithAuth } from "utils/api";
import { asDate, asVolume } from "utils/text";
import QualModal from "./QualModal";

export default function ListTable(props) {
  const [tableData, setTableData] = useState([]);
  const [paginationParam, setPaginationParam] = useState({
    currentPage: 1,
    perPage: 15,
    total: 0,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [selectedQual, setSelectedQual] = useState(false);

  const onGetTableData = (res) => {
    setTableData(res.data.data);
    setPaginationParam({
      ...paginationParam,
      currentPage: res.data.current_page,
      total: res.data.total,
    });
    setIsLoading(false);
  };
  const onFailTableData = () => {
    setIsLoading(false);
  };
  const loadTableData = (paginationParam0) => {
    setIsLoading(true);
    const params = {
      ...props.searchParam,
      page: paginationParam0.currentPage,
      per_page: paginationParam0.perPage,
    };
    const q = Object.keys(params)
      .map((k) => k + "=" + params[k])
      .join("&");
    callGetApiWithAuth(
      `my_team/unilevel_list/search?${q}`,
      onGetTableData,
      onFailTableData
    );
  };
  const onPageChange = (page) => {
    const paginationParam0 = {
      ...paginationParam,
      currentPage: page,
    };
    loadTableData(paginationParam0);
  };

  useEffect(() => {
    const paginationParam0 = {
      ...paginationParam,
      currentPage: 1,
    };
    loadTableData(paginationParam0);
  }, [props.searchParam]);

  return (
    <>
      <TablePanel
        title={`Searched Results`}
        data={tableData}
        loading={isLoading}
        paginationParam={paginationParam}
        onPageChange={onPageChange}
        columns={[
          {
            title: "ID",
            key: "uuid",
            render: (_, record) => <span>#{record.uuid}</span>,
          },
          {
            title: "Level",
            key: "level",
            render: (_, record) => <span>{record.level}</span>,
          },
          {
            title: "Username",
            key: "username",
            render: (_, record) => (
              <div className="d-flex align-items-center">
                <a
                  href="javascript:void(0)"
                  onClick={() => props.goUser(record)}
                >
                  {record.username}
                </a>
              </div>
            ),
          },
          {
            title: "Name",
            key: "name",
            render: (_, record) => (
              <div className="d-flex align-items-center">
                <UserAvatar
                  image={record.image}
                  title={`${record.first_name} ${record.last_name}`}
                  status={varKey("user.status", record.status)}
                  type={varKey("user.type", record.type)}
                  typeLabel={varLabel("user.type", record.type)}
                  joinDate={asDate(record.created_at)}
                />
                {record.social_messenger &&
                  record.social_messenger.facebook_enabled * 1 === 1 &&
                  record.social_messenger.facebook_link && (
                    <span className="chat-icon">
                      <FaFacebookMessenger
                        onClick={() => {
                          window.open(
                            record.social_messenger.facebook_link,
                            "_blank"
                          );
                        }}
                      />
                    </span>
                  )}
                {record.social_messenger &&
                  record.social_messenger.telegram_enabled * 1 === 1 &&
                  record.social_messenger.telegram_link && (
                    <span className="chat-icon">
                      <FaTelegramPlane
                        onClick={() => {
                          window.open(
                            record.social_messenger.telegram_link,
                            "_blank"
                          );
                        }}
                      />
                    </span>
                  )}
                {record.social_messenger &&
                  record.social_messenger.whatsapp_enabled * 1 === 1 &&
                  record.social_messenger.whatsapp_link && (
                    <span className="chat-icon">
                      <FaWhatsapp
                        onClick={() => {
                          window.open(
                            record.social_messenger.whatsapp_link,
                            "_blank"
                          );
                        }}
                      />
                    </span>
                  )}
              </div>
            ),
          },
          {
            title: "Country",
            key: "country",
            render: (_, record) => <CountryFlag country={record.country} />,
          },
          {
            title: "Enroller",
            key: "enroller",
            render: (_, record) => <span>{record.enroller.username}</span>,
          },
          {
            title: "Promoter Rank",
            key: "rank_id",
            render: (_, record) => (
              <span>
                {varIs("user.type", record.type, "affiliate") ? (
                  <RankBadge label={record.rank.name} />
                ) : (
                  ""
                )}
              </span>
            ),
          },
          {
            title: "Builder Rank",
            key: "builder_rank_id",
            render: (_, record) => (
              <span>
                {varIs("user.type", record.type, "affiliate") ? (
                  <RankBadge label={record.builder_rank.name} />
                ) : (
                  ""
                )}
              </span>
            ),
          },
          {
            title: "Subscription",
            key: "subscription",
            render: (_, record) => <span>{record.subscription_count}</span>,
          },
          {
            title: "MP",
            key: "mp",
            render: (_, record) => (
              <span>{asVolume(record.qualification.mp)}</span>
            ),
          },
          {
            title: "MP (on Subscriptions)",
            key: "c_mp",
            render: (_, record) => (
              <span>{asVolume(record.qualification.c_mp)}</span>
            ),
          },
          {
            title: "AP",
            key: "ap",
            render: (_, record) => (
              <span>{asVolume(record.qualification.ap)}</span>
            ),
          },
          {
            title: "EOP",
            key: "eop",
            render: (_, record) => (
              <span>{asVolume(record.qualification.eop)}</span>
            ),
          },
          {
            title: "OP",
            key: "op",
            render: (_, record) => (
              <span>{asVolume(record.qualification.op)}</span>
            ),
          },
        ]}
      />
      {selectedQual && (
        <QualModal
          selectedQual={selectedQual}
          setSelectedQual={setSelectedQual}
        />
      )}
    </>
  );
}
